// @flow
import {isTotalWithoutChildren} from './isTotalWithoutChildren';

import type {TreeRowData} from '../typedef';

export const isTotalRow = <DataRow = {||}>(row: TreeRowData<DataRow>): boolean => Boolean(
    isTotalWithoutChildren(row) && row.expanded === undefined
);

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../typedef");
